import React, {ReactElement, SyntheticEvent} from "react";
import {connect} from "react-redux";
import {AlertType, IAlertState, setAlert} from "../../redux/slice/alertSlice";
import Snackbar from "@mui/material/Snackbar";
import {Alert, styled, Typography} from '@mui/material';
import {alertDurationInMs} from "../../Config";
import {RootState} from "../../redux/store";


const AlertText = styled(Typography)(({theme}) => ({
    fontSize: 18,
    textTransform: 'none',
}));

interface IProps {
    alert: IAlertState;
    setAlert: ({alertOpen, alertType, alertText}: {
        alertOpen: boolean,
        alertType: AlertType,
        alertText: string
    }) => void;
}

function CustomizedAlert(props: IProps): ReactElement {
    const {alert: {alertOpen, alertType, alertText}, setAlert} = props;

    // Do not display empty sentence
    if (alertText === null || alertText === "")
        return null;

    // Do not close Snackbar if click happens somewhere else
    const handleAutoClose = (event: SyntheticEvent, reason: string) => {
        if (reason === "clickaway") {
            return;
        }
        setAlert({alertOpen: false, alertType, alertText});
    };

    return (
        <Snackbar
            open={alertOpen}
            autoHideDuration={alertDurationInMs}
            onClose={handleAutoClose}
            anchorOrigin={{vertical: 'top', horizontal: 'center',}}
            style={{pointerEvents: 'none'}} // Does not work via class
        >

            <Alert
                severity={alertType}
                onClose={(event) => handleAutoClose(event, "closed")}
            >
                <AlertText>{alertText}</AlertText>
            </Alert>
        </Snackbar>
    );
}

const mapStateToProps = (state: RootState) => ({
    alert: state.alert
});

const mapActionsToProps = {
    setAlert,
};

export default connect(mapStateToProps, mapActionsToProps)(CustomizedAlert);
